import { create } from "zustand";
import { getUserDetailsFromJWT } from "../hooks/useAuth";

interface AuthState {
  accessToken: string | null;
  userDetails: any | null;
  isAuthenticated: boolean;
  setAccessToken: (token: string) => void;
  logout: () => void;
  checkAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: localStorage.getItem("access_token") || null,
  isAuthenticated: false,
  userDetails: localStorage.getItem("auth")
    ? JSON.parse(localStorage.getItem("auth") || "{}")
    : null,
  setAccessToken: (token) => {
    localStorage.setItem("access_token", token);
    const decoded: any | null = getUserDetailsFromJWT(token);
    localStorage.setItem("auth", JSON.stringify(decoded));
    set({ accessToken: token, isAuthenticated: true, userDetails: decoded });
  },
  logout: () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem(`auth`);
    set({ accessToken: null, isAuthenticated: false });
  },
  checkAuth: () => {
    const token = localStorage.getItem("access_token");
    if (token) {
      set({ accessToken: token, isAuthenticated: true });
    } else {
      set({ isAuthenticated: false });
    }
  },
}));
